/**
 * Created by Rodrigo Quesada on 09/03/17.
 */
import {Component, Input} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {FileInfo} from '../../../domain/model/common/file/file-info.class';
import {FileLocation} from '../service/file-location.class';
import {FileListService} from '../service/file-list.service';
import assign = require('core-js/fn/object/assign');

// region Other Classes
export class FileListComponentModel {

    files: FileInfo[];
    readonly fileBaseLocation: FileLocation;

    constructor(data: Readonly<FileListComponentModel>) {
        assign(this, data);
    }
}
// endregion

@Component({
    selector: 'my-file-list',
    template: require('./file-list.component.html'),
    styles: [require('./file-list.component.scss')]
})
export class FileListComponent {

    // region Input
    model$ = new BehaviorSubject<FileListComponentModel | undefined>(undefined);

    @Input() get model(): FileListComponentModel | undefined {
        return this.model$.getValue();
    }

    set model(value: FileListComponentModel | undefined) {
        this.model$.next(value);
    }

    // endregion

    fileDownloadingStatus: { [fileId: string]: boolean } = {};
    fileDeletingStatus: { [fileId: string]: boolean } = {};

    constructor(private readonly _fileListService: FileListService) {
    }

    downloadFile(file: FileInfo) {
        if (!this.fileDownloadingStatus[file.id]) {
            this.fileDownloadingStatus[file.id] = true;
            this._fileListService.download(this.model!.fileBaseLocation, file)
                .finally(() => this.fileDownloadingStatus[file.id] = false)
                .subscribe();
        }
    }

    removeFile(file: FileInfo) {
        if (!this.fileDeletingStatus[file.id]) {
            this.fileDeletingStatus[file.id] = true;
            this._fileListService.remove(this.model!.fileBaseLocation, file)
                .finally(() => this.fileDeletingStatus[file.id] = false)
                .subscribe(() => {
                    this.model!.files.splice(this.model!.files.indexOf(file), 1);
                });
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/files/file-list/file-list.component.ts